import LyAutoText from './src/main'

LyAutoText.install = function (Vue) {
    Vue.component(LyAutoText.name, LyAutoText)
}

export default LyAutoText